import LeagueMessagesPlaceholder from './LeagueMessagesPlaceholder';

export default LeagueMessagesPlaceholder;
